import { Loadable } from '@/commons/lodeable';
import { Card, CardContent, CardHeader, Divider } from '@mui/material';
import { lazy } from 'react';

type Props = {
  title?: string;
  isCurrency?: boolean;
  data?: {
    values: any;
    categories: string[];
  };
};

export const CardDetailColumn = ({ data, title, isCurrency }: Props) => {
  if (!data) {
    return null;
  }
  const StackVertical = Loadable(lazy(() => import('@/commons/chart/stack-vertical')));
  return (
    <Card sx={{ width: '100%' }}>
      <CardHeader title={title ?? 'Cash Journal'} />
      <Divider />
      <CardContent sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around' }}>
        <StackVertical
          chart={{
            options: {
              chart: {},
            },

            series: data,
          }}
          isCurrency={isCurrency}
        />
      </CardContent>
    </Card>
  );
};
